var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamongicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_724_23561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00945 0L3.92188 0.296163V8.89013L4.00945 8.97711L8.01881 6.61909L4.00945 0Z",
    fill: "#5B8BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00936 0L0 6.61909L4.00936 8.97714V4.80589V0Z",
    fill: "#6995FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00931 9.73183L3.95996 9.79169V12.853L4.00931 12.9965L8.02109 7.375L4.00931 9.73183Z",
    fill: "#2262FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00936 12.9965V9.73183L0 7.375L4.00936 12.9965Z",
    fill: "#3872FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00879 8.97783L8.01809 6.61985L4.00879 4.80664V8.97783Z",
    fill: "#4B80FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.61985L4.0093 8.97787V4.80664L0 6.61985Z",
    fill: "#6C97FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_724_23561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.02111,
    height: 13,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamongicon);
export default __webpack_public_path__ + "static/media/diamongicon.62962134b50710222793e894578986d4.svg";
export { ForwardRef as ReactComponent };